/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 * POST body discriminated by ``protocol``: each protocol accepts only the fields
 * needed for that integration (same idea as :class:`SingleTurnChatInferencerPolymorphicSerializer`).
 * Validation and persistence are handled by the concrete per-protocol create serializer.
 * @export
 * @interface SingleTurnChatInferencerCreatePolymorphicShared
 */
export interface SingleTurnChatInferencerCreatePolymorphicShared {
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerCreatePolymorphicShared
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicShared
   */
  credentialValue?: string | null;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerCreatePolymorphicShared interface.
 */
export function instanceOfSingleTurnChatInferencerCreatePolymorphicShared(
  value: object,
): value is SingleTurnChatInferencerCreatePolymorphicShared {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerCreatePolymorphicSharedFromJSON(
  json: any,
): SingleTurnChatInferencerCreatePolymorphicShared {
  return SingleTurnChatInferencerCreatePolymorphicSharedFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerCreatePolymorphicSharedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerCreatePolymorphicShared {
  if (json == null) {
    return json;
  }
  return {
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    credentialValue: json['credential_value'] == null ? undefined : json['credential_value'],
  };
}

export function SingleTurnChatInferencerCreatePolymorphicSharedToJSON(
  value?: SingleTurnChatInferencerCreatePolymorphicShared | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    credential_value: value['credentialValue'],
  };
}
